import { StyleSheet, ColorValue } from 'react-native';

interface StyleProps {}

export const makeStyles = (): any => {
  return StyleSheet.create({});
};
